import EventEmitter, { EventEmitterCallback } from "./EventEmitter";
import parseJSON from './parseJSON';

const { NOTIFICATIONS_URL } = window.ENV;

const eventEmitter = new EventEmitter();
let _apiUrl = NOTIFICATIONS_URL;
let _inited = false;
let _ws: WebSocket | null = null;
// let _onChangeStateCallback = null;
let _token: string | null = null;
let _project: 'elsa' | 'heat' = null;
let _forceClosed: boolean = false;
let _lastState: string | null = null;
let _lastId: number = null;

// export const onChangeState = ( onChangeStateCallback ) => _onChangeStateCallback = onChangeStateCallback;
export const onMessage = (callback: EventEmitterCallback) => eventEmitter.on('event', callback);
export const setToken = (token: string | null) => {
  if (_token === token) return;
  _token = token;
  auth();
};
export const setNotificationsUrl = (apiUrl: string) => _apiUrl = apiUrl;
export const setProject = (project: typeof _project) => _project = project;

export const init = () => createChannel();

const send = (method: string, params: {}) => _ws.send(JSON.stringify({ method, params }));

const auth = () => {
  if (!_ws || _ws.readyState !== WebSocket.OPEN) return;
  // console.log(`[EVENTS] auth with token "${_token}"`);
  send('setAuth', { token: `Bearer ${_token}`, project: _project });
};

const changeState = (state: string) => {
  if (_lastState === state) return;
  _lastState = state;
  // if (_onChangeStateCallback) _onChangeStateCallback(state);
};

const createChannel = () => {
  _inited = true;
  close();
  const url = _apiUrl;
  console.log(`[EVENTS] create at url: ${url}`);
  _ws = new WebSocket(url);
  _ws.onopen = () => {
    console.log(`[EVENTS] open`);
    changeState('online');
    auth();
  };
  _ws.onclose = () => {
    if (_forceClosed) {
      _forceClosed = false;
      return;
    }
    _ws = null;
    console.log(`[EVENTS] close`);
    changeState('offline');
    setTimeout(createChannel, 3000);
  };
  _ws.onerror = (e) => {
    // console.log(`[EVENTS] error`, e);
    // setTimeout(createChannel, 3000);
  };
  _ws.onmessage = (message) => {
    // console.log(`[EVENTS] message: `, message.data);
    const json = parseJSON(message.data);
    if (!json) return;
    const { id, data } = json;
    if (data.key === 'AUTH') {
      if (_lastId) send('getHistory', { fromId: _lastId });
    } else {
      eventEmitter.emit('event', data);
    }
    if (id) _lastId = id;
  };
};

const close = () => {
  if (!_ws) return;
  _forceClosed = true;
  _ws.close();
};

if (window && window.addEventListener) {
  window.addEventListener('pagehide', () => {
    close();
  });

  window.addEventListener('pageshow', () => {
    if (_inited && !_ws) createChannel();
  });
}